import type * as UpdateOrganizationContactAPI from 'ab-api/web/organizationContact/updateOrganizationContact';

import { isValidEmail } from '@acceligentllc/shared/utils/email';

export class EmailContactFM {
	email: string;

	static validate(form: EmailContactFM) {
		const errors: ValidationErrors = {};

		if (!isValidEmail(form.email)) {
			errors.email = 'Email invalid';
		}

		return errors;
	}

	static toUpdateRM(
		form: EmailContactFM
	): UpdateOrganizationContactAPI.W_OrganizationContact_UpdateOrganizationContact_RM {
		return {
			...form,
		};
	}
}
